import { Component, OnInit, OnDestroy, HostBinding, ViewChild } from '@angular/core';

import { combineLatest, Observable, of, Subject, Subscription } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

import { Instance } from '../../models';
import { JobsService } from '../../services';
import { InstanceService } from '../../services/instance.service';
import * as _ from 'lodash';
import { MatTabGroup } from '@angular/material/tabs';
import { PageEvent } from '@angular/material/paginator';
import ISearchProcessesPaginatedParams = ZoningAPI.ISearchProcessesPaginatedParams;

@Component({
    standalone: false,
    selector: 'app-instance-view',
    templateUrl: './instance-view.component.html',
    styleUrls: ['./instance-view.component.scss']
})
export class InstanceViewComponent implements OnInit, OnDestroy {
    destroy$ = new Subject<boolean>();
    instance: Instance;
    jobs$: Observable<ITaskModel[]>;

    pageEvent: PageEvent;

    @ViewChild('tabs') tabs: MatTabGroup;

    subscriptions: Subscription[] = [];
    activeJobsSearchParams: ISearchProcessesPaginatedParams;
    showSpinner: boolean;

    constructor(private readonly instanceService: InstanceService, private readonly jobsService: JobsService) {}

    @HostBinding('class')
    hostClass = 'instance-info';

    get jobsTabActive() {
        return !!this.tabs && this.tabs.selectedIndex === 2;
    }

    get totalJobsCount() {
        return this.jobsService.totalActiveJobsCount;
    }

    ngOnInit() {
        this.instanceService.currentInstance
            .pipe(
                takeUntil(this.destroy$),
                filter(instance => instance !== null)
            )
            .subscribe(instance => {
                this.instance = instance;
            });

        this.jobs$ = combineLatest([
            this.jobsService.processes,
            this.instanceService.currentInstance.pipe(filter(instance => instance !== null))
        ]).pipe(
            switchMap(([jobs, currentInstance]) => {
                return of(
                    jobs.filter(
                        job =>
                            job.instanceId === currentInstance.Id ||
                            _.get(job, 'state', '').toLowerCase() === _.get(currentInstance, 'State', '').toLowerCase()
                    )
                );
            })
        );

        this.subscriptions.push(
            this.jobsService.processesListChanged.subscribe(_value => {
                this.pageChanged(this.pageEvent);
            })
        );
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    pageChanged(event: PageEvent, getArchived: boolean = false) {
        this.pageEvent = event;

        this.fetchJobs(getArchived);
    }

    searchParamsChanged(searchParams: ISearchProcessesPaginatedParams, getArchived: boolean = false) {
        this.activeJobsSearchParams = searchParams;

        this.fetchJobs(getArchived);
    }

    fetchJobs(getArchived: boolean = false) {
        this.showSpinner = true;
        this.jobsService
            .fetchJobs(
                this.activeJobsSearchParams,
                getArchived,
                _.get(this.pageEvent, 'pageIndex', 0) + 1,
                _.get(this.pageEvent, 'pageSize')
            )
            .subscribe(() => {
                this.showSpinner = false;
            });
    }
}
